import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        as: 'span',
        padding: `${remCalc(6)} ${remCalc(8)}`,
        textStyle: 'body-xxsmall',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        color: 'label.text.primary',
        backgroundColor: 'label.background.primary',
    },
    variants: {
        light: {color: 'label.text.secondary', backgroundColor: 'label.background.secondary'},
        violet: {
            color: 'text.inverse',
            backgroundColor: 'text.violet',
        },
        coupon: {
            color: 'text.success',
            backgroundColor: 'background.success',
            fontStyle: 'body-xxsmall',
            fontWeight: 'bold',
        },
        grey: {color: 'text.secondary', backgroundColor: 'background.grey'},
        error: {color: 'text.danger', backgroundColor: 'background.danger'},
    },
    parts: ['color', 'backgroundColor'],
}
